import React from 'react';
import { Box, Switch, Typography } from "@mui/material";
import clientInsightsStyles from "../Client/ClientInsights.styles";

interface SwitchComponentProps {
  rated?: boolean | undefined;
  totalCount?: number;
  ratedCount?: number;
  onToggleChange?: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  firstText?: string;
  secondText?: string;
  hideUnderline?: boolean;
  disabled?: boolean;
}

const SwitchComponent: React.FC<SwitchComponentProps> = ({
  rated,
  totalCount,
  ratedCount,
  onToggleChange,
  firstText = "All",
  secondText = "Rated",
  hideUnderline = false,
  disabled = false,
}) => {
  return (
    <Box>
      <Box sx={clientInsightsStyles["Toogle__switch-container"]}>
        <Typography
          sx={{
            ...clientInsightsStyles["Toogle__switch-typography"],
            color: rated ? "rgba(66, 71, 81, 0.7)" : "rgba(26, 26, 26, 1)", // Apply colors based on toggle state
          }}
        >
          {firstText} ({totalCount})
        </Typography>
        <Switch
          checked={rated ?? false}
          onChange={onToggleChange}
          sx={clientInsightsStyles["Toogle__switch"](rated ?? false)}
          disabled={disabled}
        />
        <Typography
          sx={{
            ...clientInsightsStyles["Toogle__switch-typography"],
            color: rated ? "rgba(26, 26, 26, 1)" : "rgba(66, 71, 81, 0.7)", // Apply colors based on toggle state
          }}
        >
          {secondText} ({ratedCount})
        </Typography>
      </Box>
      {/* Bottom border merging with table */}
      {!hideUnderline && (
        <Box
          sx={{
            borderBottom: `1px solid rgba(229, 229, 229, 1)`,
            width: "100%",
          }}
        />
      )}
    </Box>
  );
};

export default SwitchComponent;
